import { Body, Container, Head, Html, Link, Preview, Section, Text } from '@react-email/components';
import { BaseEmailTemplateProps } from './type';


type CustomerPromotionCodeProps = BaseEmailTemplateProps<any, any>;

export const CustomerPromotionCode = ({
  userVariables,
  contextVariables,
  emailMessages,
  locale,
}: CustomerPromotionCodeProps & { emailMessages: any; locale: string }) => {
  const { promotionCode } = contextVariables;
  const { subject, body } = userVariables;

  if (!promotionCode) return null;

  return (
    <Html>
      <Head />
      <Preview>{subject}</Preview>

      <Body style={main}>
        <Container style={container}>
          {/* Header Section */}
          <Section style={header}>
            <Text style={storeName}>{promotionCode.store?.name}</Text>
          </Section>

          {/* Message Section */}
          <Section style={messageSection}>
            <div dangerouslySetInnerHTML={{ __html: body }} style={messageText} />
          </Section>

          {/* Promotion Code Section */}
          {/* <Section style={codeSection}>
            <Text style={codeLabel}>{emailMessages.your_code}</Text>
            <Text style={codeValue}>{promotionCode.code}</Text>
            {promotionCode.expiresAt && (
              <Text style={expiryText}>
                {emailMessages.expires_on} {formatDate(promotionCode.expiresAt, locale)}
              </Text>
            )}
          </Section> */}

          {/* Footer */}
          <Text style={footerText}>{emailMessages.footer_text}</Text>
        </Container>
      </Body>
    </Html>
  );
};

const emerald = {
  50: '#f0fdf4',
  500: '#10b981',
  600: '#059669',
};

const main = {
  fontFamily:
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  backgroundColor: '#ffffff',
};

const container = {
  margin: '0 auto',
  padding: '40px 20px',
  width: '600px',
  maxWidth: '100%',
};

const header = {
  marginBottom: '32px',
};

const storeName = {
  fontSize: '24px',
  lineHeight: '1.3',
  fontWeight: '700',
  color: '#111827',
  margin: '0',
  textAlign: 'center' as const,
};

const messageSection = {
  marginBottom: '32px',
};

const messageText = {
  fontSize: '16px',
  lineHeight: '1.5',
  color: '#374151',
  margin: '0',
  textAlign: 'center' as const,
};

const codeSection = {
  marginBottom: '32px',
  textAlign: 'center' as const,
  padding: '24px',
  backgroundColor: emerald[50],
  borderRadius: '8px',
};

const codeLabel = {
  fontSize: '14px',
  color: '#374151',
  margin: '0 0 8px 0',
};

const codeValue = {
  fontSize: '32px',
  fontWeight: '700',
  color: emerald[600],
  margin: '0 0 8px 0',
  letterSpacing: '0.1em',
};

const expiryText = {
  fontSize: '14px',
  color: '#6b7280',
  margin: '8px 0 0 0',
};

const ctaSection = {
  textAlign: 'center' as const,
  marginBottom: '32px',
};

const ctaButton = {
  backgroundColor: emerald[500],
  color: '#ffffff',
  fontSize: '16px',
  textDecoration: 'none',
  padding: '12px 32px',
  borderRadius: '6px',
  display: 'inline-block',
  fontWeight: '500',
  textAlign: 'center' as const,
};

const footerText = {
  fontSize: '14px',
  color: '#6b7280',
  textAlign: 'center' as const,
  margin: '0',
};
